import { ISelectorOptions } from 'components/common'
import { ScheduledBookingProcessOnType } from 'generated/graphql'

export const ProcessOnTypeValues: ISelectorOptions = [
  { value: ScheduledBookingProcessOnType.SameDay, label: 'Same Day' },
  { value: ScheduledBookingProcessOnType.DayBefore, label: 'Day Before' },
]
